// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b410bb5e","239":"28e43155","455":"e3c41021"}[chunkId] + ".chunk.js";
};